import { Injectable, Injector } from '@angular/core';
import { ProductListAnalyticsService } from './product-list-analytics.service';

@Injectable({ providedIn: 'root' })
export class ProductListComparisonAnalyticsService extends ProductListAnalyticsService {
  constructor(injector: Injector) {
    super(injector);
    this.analyticsListName$.next('Сomparison_1');
  }
}
